// TODO: Clean up how we treat values as both dates and strings
import { ValidationType } from '@/constants/validationTypes';
import { Validation } from '../../sceneDataSchema';
import { z } from 'zod';

export function dateValidator(validations: Validation[]) {
  let required = false;

  const refinedSchema = validations.reduce((schema, validation) => {
    switch (validation.type) {
      case ValidationType.Min: {
        if (typeof validation.value == 'number') {
          return schema;
        }

        const minDate = new Date(validation.value);
        return schema.refine(
          (val) => {
            try {
              const source = new Date(val);
              const target = new Date(minDate);
              return source.getTime() >= target.getTime();
            } catch (error) {
              console.warn(error);
              return false;
            }
          },
          `Date must be on or after ${minDate.toISOString().split('T')[0]}`
        );
      }

      case ValidationType.Max: {
        if (typeof validation.value == 'number') {
          return schema;
        }

        const maxDate = new Date(validation.value);
        return schema.refine(
          (val) => {
            try {
              const source = new Date(val);
              const target = new Date(maxDate);
              return source.getTime() <= target.getTime();
            } catch (error) {
              console.warn(error);
              return false;
            }
          },
          `Date must be on or before ${maxDate.toISOString().split('T')[0]}`
        );
      }

      case ValidationType.Required:
        required = true;

        return schema.refine((val) => val.trim() !== '', 'Field is required');
      default:
        return schema;
    }
  }, z.string());

  if (required) {
    return refinedSchema;
  }

  return refinedSchema.nullable();
}
